import {LoadingButton} from "@mui/lab";
import {Typography} from "@mui/material";
import {withStyles} from "@mui/styles";
import moment from "moment";
import {useEffect, useState} from "react";
import {ADD, PLANNED_ACTION} from "../../../Utils/constants";
import AddOpportunityActionModal from "../../Calendar/Widgets/CalendarWidget/AddOpportunityActionModal";

const useStyles = (_theme) => ({
    card: {
        backgroundColor: "#fff",
    },
    cardActions: {
        display: "flex",
        flexDirection: "row-reverse",
        marginRight: "-8px",
        marginBottom: "-8px",
    },
    box: {
        width: "19px",
        height: "19px",
        borderColor: "#cacaca",
        borderStyle: "solid",
        marginRight: "5px",
    },
    none: {
        background: "transparent",
    },
    unknown: {
        background: "yellow",
    },
    attending: {
        background: "green",
    },
    not_attending: {
        background: "red",
    },
    tentative: {
        background: "yellow",
    },
});

function NextPlannedAction(props) {
    const {
        opportunity,
        opportunityDetails,
        events,
        plannedAction,
        opportunityLoading,
        getCalendarLoading
    } = props;
    const [action, setAction] = useState({});
    const [openOpportunityActionModal, setOpenOpportunityActionModal] = useState(false);
    const [eventToUpdate, setEventToUpdate] = useState({});
    const [jobEmail, setJobEmail] = useState([]);

    useEffect(() => {

        if (opportunity) {
            // The saved NPA in the store is newer than the open opportunity loaded with the person, so it wins
            if (plannedAction && plannedAction.opportunity_id == opportunity.opportunity_id) {
                setAction(plannedAction);
            } else if (opportunity.opportunity_actions) {
                setAction(opportunity.opportunity_actions);
            } else {
                setAction({});
            }
        } else {
            setAction({});
        }
    }, [opportunity, plannedAction]);

    const handleAddOrUpdateEvent = () => {
        const opportunityId = opportunityDetails ?? opportunityDetails.opportunity_id;

        if (opportunityId) {
            const _eventToUpdate = events
                ?.filter((e) => e.event_id?.split("__").length === 2 && e.event_id?.split("__")[1] == opportunityId)
                .sort((a, b) => new Date(b.created) - new Date(a.created))
                .at(0);

            const _jobEmail = Object.values(opportunityDetails.related_objects.jobs).filter((item) => item.job_is_primary == 1);

            setJobEmail(_jobEmail);
            setEventToUpdate(_eventToUpdate);
            setOpenOpportunityActionModal(true);
        }
    };

    const handleAddOpportunityActionModalClose = (_refresh = false) => {
        setOpenOpportunityActionModal(false);
        setEventToUpdate(null);
    };

    return (
        <>
            <div>
                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <Typography variant='h6' component='div' gutterBottom>
                        Planned
                        Action
                    </Typography>
                    <div style={{display: "flex"}}>
                        {action && !action.opportunity_action_due_time && (
                            <LoadingButton
                                color='primary'
                                variant='contained'
                                size='small'
                                style={{textTransform: "capitalize"}}
                                disabled={opportunityLoading}
                                onClick={handleAddOrUpdateEvent}
                                loading={getCalendarLoading}
                            >
                                Create
                            </LoadingButton>
                        )}
                    </div>
                </div>
                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    {action && action.opportunity_action_due_time ? (
                        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                            <Typography variant='body2' color='site.main' gutterBottom style={{margin: " 0 5px 0 0"}}>
                                <b>{moment(action.opportunity_action_due_time).format("DD/MM/YYYY HH:mm")}</b>
                            </Typography>
                        </div>
                    ) : (
                        ""
                    )}
                </div>
                {!action.opportunity_action_type && (
                    <Typography variant='body2' color='site.main'>
                        There is no planned action for this opportunity
                    </Typography>
                )}
            </div>
            <AddOpportunityActionModal
                open={openOpportunityActionModal}
                currentEvent={eventToUpdate}
                tab='phone_meeting'
                jobEmail={jobEmail}
                handleClose={handleAddOpportunityActionModalClose}
                startDate={null}
                endDate={null}
                opportunity={opportunityDetails}
                mode={ADD}
                actionType={PLANNED_ACTION}
            />
        </>
    );
}

export default withStyles(useStyles)(NextPlannedAction);
